import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { CardMaskKind, ICardField } from '../../driver-background-check.view-models';
import { DriverBackgroundCheckStateService } from '../../driver-background-check-state.service';

@Component({
  selector: 'app-bgc-field-row',
  templateUrl: './bgc-field-row.component.html',
  styleUrls: ['./bgc-field-row.component.scss', '../../driver-background-check.component.scss']
})
export class BgcFieldRowComponent {
  @Input() label: string;
  @Input() value: string;
  @Input() mask: CardMaskKind;
  @Input() alwaysMask: boolean;
  @Input() fields: ICardField[];

  isMaskPIIActive$: Observable<boolean>;
  ssnPreMasked$: Observable<boolean>;

  constructor(stateService: DriverBackgroundCheckStateService) {
    this.isMaskPIIActive$ = stateService.isMaskPIIActive$;
    this.ssnPreMasked$ = stateService.ssnPreMasked$;
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/driver-background-check/components/bgc-field-row/bgc-field-row.component.ts